import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}


export const getAllServices = async (businessId?: string): Promise<any> => {
  try {
    const userId = getUserId();
    if (!userId) throw new Error("User ID not found. Please log in again.");
    
    let url = `/services/getallInWeb/${businessId}`;
   
    const response = await apiClient.get<any>(url);
    let data: any = response.data;

    const deletedNamePattern = /[-—]\s*deleted\b/i;
    const filterDeletedByName = (arr: any[]) =>
      arr.filter((s: any) => {
        const name = String(
          s.name || s.title || s.service_name || s.label || ""
        ).trim();
        return !deletedNamePattern.test(name);
      });

    if (Array.isArray(data)) {
      data = filterDeletedByName(data);
    } else if (data && Array.isArray(data.services)) {
      data.services = filterDeletedByName(data.services);
    } else if (data && Array.isArray(data.data)) {
      data.data = filterDeletedByName(data.data);
    }

    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Fetch services for a specific branch
 */
export const getBranchServices = async (branchId: string): Promise<any> => {
  try {
    const userId = getUserId();
    if (!userId) throw new Error("User ID not found. Please log in again.");
    
    const url = `/services/getallInWeb/${branchId}`;
    const response = await apiClient.get<any>(url);
    let data: any = response.data;

    const deletedNamePattern = /[-—]\s*deleted\b/i;
    const filterDeletedByName = (arr: any[]) =>
      arr.filter((s: any) => {
        const name = String(
          s.name || s.title || s.service_name || s.label || ""
        ).trim();
        return !deletedNamePattern.test(name);
      });

    if (Array.isArray(data)) {
      data = filterDeletedByName(data);
    } else if (data && Array.isArray(data.services)) {
      data.services = filterDeletedByName(data.services);
    } else if (data && Array.isArray(data.data)) {
      data.data = filterDeletedByName(data.data);
    }

    return data;
  } catch (error) {
    throw error;
  }
};
// ...existing code...

export const createService = async (branchData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/services/create", branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateService = async (
  id: string,
  branchData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/services/update/${id}`, branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteService = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/services/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
